module.exports = __webpack_public_path__ + "media/images/white-slider-arrows-a2ed8980.png";